import { SxProps, Theme } from '@mui/material';

export const copyButtonSx: SxProps<Theme> = {
  display: 'grid',
  placeItems: 'center',
  width: '1.25rem',
  height: '1.25rem',
  border: 0,
  borderRadius: '0.3125rem',
  padding: 0,
  backgroundColor: 'transparent',
  color: 'inherit',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: (theme) => theme.palette.custom.OV.sys.surfaceContainerHigh,
    color: (theme) => theme.palette.custom.OV.sys.onBackground,
  },
};

export const kickerSx: SxProps<Theme> = {
  fontSize: '0.625rem',
  fontWeight: 700,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
  flexShrink: 0,
};

export const labelChipSx: SxProps<Theme> = {
  fontSize: '0.625rem',
  lineHeight: 1.4,
  padding: '0.0625rem 0.375rem',
  borderRadius: 999,
  backgroundColor: (theme) => theme.palette.custom.OV.sys.surfaceContainerHigh,
  color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
};

export const noteSx: SxProps<Theme> = {
  mt: '0.375rem',
  fontSize: '0.6875rem',
  lineHeight: 1.45,
  color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  '& p': { margin: 0 },
};
